import React, { useState, useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import axios from 'axios';

function Cadastro() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    nome: '',
    email: '',
    telefone: '',
    cpf: '',
    endereco: '',
    bairro: '',
    cidade: '',
    cep: '',
    plano: searchParams.get('plano') || 'BÁSICO'
  });

  const planos = [
    { id: 'BÁSICO', nome: 'BÁSICO', velocidade: '200 MB', preco: 'R$ 68,00' },
    { id: 'COMFORT', nome: 'COMFORT', velocidade: '400 MB', preco: 'R$ 78,00' },
    { id: 'PREMIUM', nome: 'PREMIUM', velocidade: '600 MB', preco: 'R$ 88,00' },
    { id: 'HARDCORE GAMER', nome: 'HARDCORE GAMER', velocidade: '1 GB', preco: 'R$ 128,00' }
  ];

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Validar se o email foi preenchido
    if (!formData.email) {
      alert('Por favor, preencha o email para continuar.');
      return;
    }
    
    // Mostrar loading
    const submitButton = e.target.querySelector('.btn-submit');
    const originalText = submitButton.innerHTML;
    submitButton.innerHTML = '<i class="fas fa-spinner fa-spin"></i> Enviando...';
    submitButton.disabled = true;
    
    try {
      // Tentar fazer POST para a API real primeiro
      try {
        console.log('Tentando conectar com a API real...');
        const response = await axios.post('http://10.0.201.35:9000/api/cadastro', formData, {
          headers: {
            'Content-Type': 'application/json',
          },
          timeout: 5000 // 5 segundos de timeout para teste rápido
        });
        
        console.log('Resposta da API real:', response.data);
        
        // Verificar se o cadastro foi bem-sucedido
        if (response.status === 200 || response.status === 201) {
          // Redirecionar para página de sucesso
          navigate('/sucesso', { 
            state: { 
              formData: formData,
              cadastroRealizado: true,
              apiResponse: response.data
            } 
          });
          return; // Sair da função se API funcionou
        }
      } catch (apiError) {
        console.log('API não está disponível, usando simulação:', apiError.message);
      }
      
      // FALLBACK: Simular sucesso se API não estiver disponível
      console.log('Dados do cadastro (simulação):', formData);
      
      // Simular delay da API
      await new Promise(resolve => setTimeout(resolve, 2000));
      
      // Simular resposta de sucesso
      const mockResponse = {
        status: 201,
        data: {
          message: 'Cadastro realizado com sucesso (simulado)',
          id: Math.floor(Math.random() * 10000),
          timestamp: new Date().toISOString(),
          note: 'API não disponível - dados salvos localmente'
        }
      };
      
      console.log('Resposta simulada da API:', mockResponse.data);
      
      // Redirecionar para página de sucesso
      navigate('/sucesso', { 
        state: { 
          formData: formData,
          cadastroRealizado: true,
          apiResponse: mockResponse.data
        } 
      });
      
    } catch (error) {
      console.error('Erro ao enviar cadastro:', error);
      
      // Restaurar botão
      submitButton.innerHTML = originalText;
      submitButton.disabled = false;
      
      if (error.code === 'ECONNABORTED') {
        alert('Timeout na conexão com o servidor. Verifique se a API está rodando em http://10.0.201.35:9000/api');
      } else if (error.response) {
        if (error.response.status === 404) {
          alert('API não encontrada. Verifique se o servidor da API está rodando em http://10.0.201.35:9000/api');
        } else {
          alert(`Erro ${error.response.status}: ${error.response.data?.message || 'Erro no servidor'}`);
        }
      } else if (error.request) {
        alert('Erro de conexão. Verifique se a API está rodando em http://10.0.201.35:9000/api');
      } else {
        alert('Erro ao enviar cadastro. Tente novamente.');
      }
    }
  };

  const formatCPF = (value) => {
    return value
      .replace(/\D/g, '')
      .replace(/(\d{3})(\d)/, '$1.$2')
      .replace(/(\d{3})(\d)/, '$1.$2')
      .replace(/(\d{3})(\d{1,2})$/, '$1-$2');
  };

  const formatTelefone = (value) => {
    return value
      .replace(/\D/g, '')
      .replace(/(\d{2})(\d)/, '($1) $2')
      .replace(/(\d{5})(\d)/, '$1-$2')
      .replace(/(-\d{4})\d+?$/, '$1');
  };

  const formatCEP = (value) => {
    return value
      .replace(/\D/g, '')
      .replace(/(\d{5})(\d)/, '$1-$2');
  };

  return (
    <div className="cadastro-page">
      <div className="container">
        <div className="section-header">
          <h1>Cadastro de Cliente</h1>
          <p>Preencha seus dados para contratar o plano escolhido</p>
        </div>

        <div className="cadastro-content">
          <div className="plano-selecionado">
            <h3>Plano Selecionado</h3>
            <div className="plano-info">
              {planos.find(p => p.id === formData.plano) && (
                <>
                  <h4>{planos.find(p => p.id === formData.plano).nome}</h4>
                  <p>Velocidade: {planos.find(p => p.id === formData.plano).velocidade}</p>
                  <p className="preco">{planos.find(p => p.id === formData.plano).preco}/mês</p>
                </>
              )}
            </div>
          </div>

          <form className="cadastro-form" onSubmit={handleSubmit}>
            <div className="form-section">
              <h3>Dados Pessoais</h3>
              
              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="nome">Nome Completo *</label>
                  <input
                    type="text"
                    id="nome"
                    name="nome"
                    value={formData.nome}
                    onChange={handleInputChange}
                    required
                  />
                </div>
                
                <div className="form-group">
                  <label htmlFor="cpf">CPF *</label>
                  <input
                    type="text"
                    id="cpf"
                    name="cpf"
                    value={formData.cpf}
                    onChange={(e) => {
                      const formatted = formatCPF(e.target.value);
                      setFormData(prev => ({ ...prev, cpf: formatted }));
                    }}
                    maxLength="14"
                    required
                  />
                </div>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="email">E-mail *</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    required
                  />
                </div>
                
                <div className="form-group">
                  <label htmlFor="telefone">Telefone *</label>
                  <input
                    type="text"
                    id="telefone"
                    name="telefone"
                    value={formData.telefone}
                    onChange={(e) => {
                      const formatted = formatTelefone(e.target.value);
                      setFormData(prev => ({ ...prev, telefone: formatted }));
                    }}
                    maxLength="15"
                    required
                  />
                </div>
              </div>
            </div>

            <div className="form-section">
              <h3>Endereço de Instalação</h3>
              
              <div className="form-group">
                <label htmlFor="endereco">Endereço Completo *</label>
                <input
                  type="text"
                  id="endereco"
                  name="endereco"
                  value={formData.endereco}
                  onChange={handleInputChange}
                  required
                />
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="bairro">Bairro *</label>
                  <input
                    type="text"
                    id="bairro"
                    name="bairro"
                    value={formData.bairro}
                    onChange={handleInputChange}
                    required
                  />
                </div>
                
                <div className="form-group">
                  <label htmlFor="cidade">Cidade *</label>
                  <input
                    type="text"
                    id="cidade"
                    name="cidade"
                    value={formData.cidade}
                    onChange={handleInputChange}
                    required
                  />
                </div>
              </div>

              <div className="form-group">
                <label htmlFor="cep">CEP *</label>
                <input
                  type="text"
                  id="cep"
                  name="cep"
                  value={formData.cep}
                  onChange={(e) => {
                    const formatted = formatCEP(e.target.value);
                    setFormData(prev => ({ ...prev, cep: formatted }));
                  }}
                  maxLength="9"
                  required
                />
              </div>
            </div>

            <div className="form-section">
              <h3>Plano</h3>
              
              <div className="form-group">
                <label htmlFor="plano">Selecione o Plano *</label>
                <select
                  id="plano"
                  name="plano"
                  value={formData.plano}
                  onChange={handleInputChange}
                  required
                >
                  {planos.map(plano => (
                    <option key={plano.id} value={plano.id}>
                      {plano.nome} - {plano.velocidade} - {plano.preco}/mês
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <div className="form-actions">
              <button type="submit" className="btn-submit">
                <i className="fas fa-paper-plane"></i>
                Enviar Cadastro
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default Cadastro; 